import { createEntityAdapter } from '@reduxjs/toolkit';
import { IJobCardReport } from '~/types/models/jobCardReport';
import { ITimeReport } from '~/types/models/timeReport';
import { IJobCardV2 } from '../../types/models/jobCard';

export const jobCardAdapter = createEntityAdapter<IJobCardV2>({
  selectId: (jobCard) => jobCard._id,
});

export const jobCarReportAdapter = createEntityAdapter<IJobCardReport>({
  selectId: (jobCardReport) => jobCardReport.ReportLineId,
});

export const timeRecordAdapter = createEntityAdapter<ITimeReport>({
  selectId: (timeRecord) => timeRecord._id,
});
